import { createActions } from 'redux-actions'

export const constants = {
  UPDATE_QUESTIONNAIRE_VIEW_UPDATE_FORM_FIELD: 'UPDATE_QUESTIONNAIRE_VIEW_UPDATE_FORM_FIELD',
  UPDATE_FORM: 'UPDATE_FORM',
  RETRIEVE_CALL_REPORT: 'RETRIEVE_CALL_REPORT'
}

export const actions = createActions({
  UPDATE_FORM: {
    REQUEST: ({ form }) => ({ form }),
    SUCCESS: success => success,
    FAILURE: error => error
  },
  RETRIEVE_CALL_REPORT: {
    REQUEST: ({ id }) => ({ id }),
    SUCCESS: success => success,
    FAILURE: error => error
  }
})